module.exports = __webpack_public_path__ + "static/media/features.f5019ffd.png";